document.addEventListener('DOMContentLoaded', () => {
	const contentNodes = Array.from(document.querySelectorAll('h1,h2,h3,h4,h5,h6,p,a,button,ul,ol'));
	const options = {
		rootMargin: '0px',
		threshold: 0.7,
	};
	contentNodes.forEach((node) => {
		const observer = new IntersectionObserver((entries, observer) => {
			entries.forEach((entry) => {
				if (entry.intersectionRatio >= 0.7) {
					entry.target.classList.add('fade-in');
					observer.unobserve(entry.target);
				}
			});
		}, options);
		observer.observe(node);
	});
});
